import React from 'react';
import Link from '../ui/link/Link';
import styles from './link.scss';

const HeaderLink = props => (
  <Link
    {...props}
    itemClassName={styles.headerLinkItem}
    anchorClassName={styles.headerLink}
  />
);

export default HeaderLink;
